function isBulgarian(language) {
  return 0 === "BG".localeCompare(language);
}

function getOrderPrefix(language) {
  return isBulgarian(language)
    ? "Вашата поръчка №"
    : "Your order #";
}

function getUsableStockName(name) {
  return name && "n/a" !== name.toString().toLowerCase()
    ? name
    : "";
}

export function buildExecutedOrderMessage(
  orderData,
  language,
  dateFormatter,
  orderTypeFormatter,
  stockNameResolver,
  priceFormatter
) {
  const localizedStockName = isBulgarian(language)
    ? (orderData.nBG || orderData.nEN)
    : (orderData.nEN || orderData.nBG);
  const stockName = getUsableStockName(localizedStockName) ||
    getUsableStockName(stockNameResolver(orderData.sc));
  const stockNameLabel = stockName ? " (" + stockName + ")" : "";
  let message = getOrderPrefix(language);
  message = message + orderData.id + ", " + dateFormatter(orderData.d) +
    ", " + orderTypeFormatter(orderData.t) + " " + orderData.sc + stockNameLabel + " " +
    orderData.qty + " X " + priceFormatter(orderData.sp, orderData.cc);

  return isBulgarian(language)
    ? message + " е изпълнена"
    : message + " is completed";
}

export function buildRejectedOrderMessage(orderData, language, dateFormatter, priceFormatter) {
  const stockName = getUsableStockName(orderData.nBG
    ? orderData.nBG
    : orderData.nEN);
  const stockNameLabel = stockName ? " (" + stockName + ")" : "";
  let message = getOrderPrefix(language);
  message = message + orderData.oid + ", " + dateFormatter(orderData.ts) +
    ", " + orderData.sc + stockNameLabel + " " +
    orderData.qty + " X " + priceFormatter(orderData.sp, orderData.cc);

  return isBulgarian(language)
    ? message + " е отказана"
    : message + " is rejected";
}
